export default "__VITE_ASSET__D6jx6R3u__"